import React, { useEffect, useState } from "react";
import PageHeadline from "../../components/shared/PageHeadline";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import "../../rules-regulations.css";
import API_URL from "../../config/constant";

export default function RulesRegulation() {
    const [currentIndex, setCurrentIndex] = useState(0);
    const { t } = useTranslation();

    const [data, setData] = useState(null);
    const locale = useSelector((state) => state.locale.locale);
    useEffect(() => {
        const fetchAboutData = async () => {
            try {
                const response = await fetch(`${API_URL}/rules-regulations?lang=${locale}`);
                if (!response.ok) {
                    throw new Error("Data not found");
                }
                const res = await response.json();
                if (res.length < 1) {
                    throw new Error("Data not found");
                }
                setData(res);
            } catch (error) {
                setData(t("raceinfo.rr", { returnObjects: true }));
            }
        };

        fetchAboutData();
    }, [t, locale]);

    return (
        <div className="text-white md:px-0 px-4 bg-white 2xl:pb-96 lg:pb-96 md:pb-80 pb-40">
            <div className="relative h-[240px] md:h-[300px] bg-brand-blue bg-cover bg-no-repeat flex justify-center items-center mt-[86px] md:mt-[109px] 2xl:mt-[136px]">
                <PageHeadline title={t('raceinfo.rrHeader')} />
            </div>
            {/* <ComingSoonBanner /> */}
            <div className="relative top-12 md:top-40 lg:top-60 bg-white 2xl:px-0 md:px-14 px-0">
                <div className="bg-white min-h-screen container mx-auto px-4 w-full font-poppins text-[#164481]">
                    <div className="flex items-start justify-start flex-col gap-y-10">
                        <p className="text-start md:w-1/2 font-bold">{t("raceinfo.rrTitle")}</p>
                    </div>
                    <div className="flex md:flex-row flex-col gap-x-24 mt-10">
                        <div className="flex flex-col md:gap-y-10 gap-y-5 mb-10">
                            {data?.map((parent, index) => (
                                <button
                                    key={index}
                                    onClick={() => setCurrentIndex(index)}
                                    className={`uppercase text-start w-52 text-lg ${currentIndex === index
                                            ? "text-[#164481] border-b border-b-[#164481] font-bold"
                                            : "text-neutral-500 font-normal border-none"
                                        }`}
                                >
                                    {parent.title}
                                </button>
                            ))}
                        </div>
                        <div>
                            <ol className="font-light list-decimal leading-loose max-md:px-4">
                                {data && data[currentIndex].data && data[currentIndex].data.map((text, key) => <li className="text-justify" key={key} dangerouslySetInnerHTML={{ __html: text.desc }}></li>)}
                            </ol>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
